import ModalConfirmationBase from 'App/components/ModalConfirmationBase/ModalConfirmationBase';
import { useTranslationCatalog } from 'domains/Catalog/hooks';

interface ZeroQuantityModalProps {
  show: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

function ZeroQuantityModal({
  show,
  onConfirm,
  onCancel,
}: Readonly<ZeroQuantityModalProps>) {
  const t = useTranslationCatalog();

  return (
    <ModalConfirmationBase
      show={show}
      title={t('transfers.new.zeroQuantityModal.title')}
      text={t('transfers.new.zeroQuantityModal.description')}
      label={t('transfers.new.zeroQuantityModal.confirm')}
      labelCancel={t('transfers.new.zeroQuantityModal.cancel')}
      appearance="primary"
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
}

export default ZeroQuantityModal;
